import { render, staticRenderFns } from "./AgendaAtividade.vue?vue&type=template&id=4dfb3624&scoped=true"
import script from "./AgendaAtividade.vue?vue&type=script&lang=js"
export * from "./AgendaAtividade.vue?vue&type=script&lang=js"
import style0 from "./AgendaAtividade.vue?vue&type=style&index=0&id=4dfb3624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb3624",
  null
  
)

export default component.exports